import { render, staticRenderFns } from "./MarketingReceiveAgreePop.vue?vue&type=template&id=25c5d9ee&"
import script from "./MarketingReceiveAgreePop.vue?vue&type=script&lang=ts&"
export * from "./MarketingReceiveAgreePop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports